import resources from './resources';
import products from './products';
import youtube from './youtube';
import color from './color';
import toastr from './toastr';
import files from './files';
import confirmAction from './confirm-action';
import confirmDelete from './confirm-delete';
import loader from './loader';
import order from './order';
import sse from './sse';
import date from './date';
import maintenance from './maintenance';
import actionBar from './action-bar';
import bootstrap from './bootstrap';
import datepicker from './datepicker';
import multirefCheckbox from './multiref-checkboxes';
import complexCheckbox from './complex-checkboxes';
import scroll from './scroll';
import contextualBack from './contextual-back';
import tableAction from './table-action';
import navbar from './navbar';
import pdfButton from './pdf-button';
import dirtyForm from './dirtyForm';
import search from './search';
//import cgu from './cgu';
import copyField from './copyField';

import popupHelp from './popup-help';
import backButton from './back-button';

export default function bind() {
  [
    scroll,
    bootstrap,
    sse,
    loader,
    actionBar,
    contextualBack,
    confirmAction,
    confirmDelete,
    toastr,
    resources,
    products,
    youtube,
    color,
    files,
    order,
    date,
    maintenance,
    datepicker,
    multirefCheckbox,
    tableAction,
    navbar,
    pdfButton,
    dirtyForm,
    search,
    complexCheckbox,
    //cgu,
    popupHelp,
    backButton,
    copyField,
  ].map(plugin => plugin.call(this));
}



// WEBPACK FOOTER //
// ./src/plugins/index.js